import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-section sz-red sz-white--text py-9" }
const _hoisted_2 = { class: "text-h2 font-weight-medium text-center" }
const _hoisted_3 = { class: "mb-4 font-weight-medium text-center" }

import InfoSectionTiles from './InfoSectionTiles.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoSectionHome',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('home.infoSection.title')), 1),
    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('home.infoSection.subtitle')), 1),
    _createVNode(InfoSectionTiles, { class: "info-section__tiles" })
  ]))
}
}

})